import { createSelector } from "reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getRoute } from "./get-route";

export type SourcesBySlug = Record<string, number>;
type SourcesById = Record<number, string>;

const getSources = (state: ResultsReduxState) => state.sources;

export const getSourcesBySlug = createSelector(
  [getSources, getRoute],
  (state_sources, route): SourcesBySlug => {
    const sources: SourcesBySlug = {};
    const route_operators = route.operators;

    for (const { id, slug } of state_sources) {
      sources[slug] = id;
    }

    for (const { source_id, source_slug } of route_operators) {
      sources[source_slug] = source_id;
    }

    return sources;
  }
);

export const getSourcesById = createSelector(
  [getSourcesBySlug],
  (sources_by_slug): SourcesById => {
    return Object.entries(sources_by_slug).reduce<Record<string, string>>(
      (sources_by_id, [source_slug, source_id]) => {
        sources_by_id[source_id] = source_slug;
        return sources_by_id;
      },
      {}
    );
  }
);
